import { useFlow } from "@Libs/Flow/hooks/useFlow";
import { PayFlow } from "../Flows/Pay/Pay";

export const usePayFlow = () => {
  return useFlow(PayFlow);
};
